"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoyaltyButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const setDefaultRoyalty_json_1 = __importDefault(require("@framework/abis/json/ERC721Simple/setDefaultRoyalty.json"));
const utils_1 = require("../../../utils");
const dialogs_1 = require("../../../dialogs");
const dialog_1 = require("./dialog");
const RoyaltyButton = (props) => {
    const { className, contract, contract: { address, contractFeatures, royalty, contractType, accessControls }, disabled, variant, } = props;
    const { address: walletAddress } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: address,
            abi: setDefaultRoyalty_json_1.default,
            functionName: "setDefaultRoyalty",
            args: [walletAddress, values.royalty],
        });
    });
    const handleRoyaltyConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    const handleRoyalty = () => {
        openDialog(dialogs_1.GlobalDialogKeys.ROYALTY, contract, {
            initialValues: { royalty },
            validationSchema: dialog_1.royaltyFormValidationSchema,
            message: "dialogs.edit",
            testId: "RoyaltyEditForm",
            disabled: false,
            onExternalConfirm: handleRoyaltyConfirmed,
        });
    };
    if (contractType === types_1.TokenType.NATIVE || contractType === types_1.TokenType.ERC20) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleRoyalty, icon: icons_material_1.PaidOutlined, message: "form.buttons.royalty", className: className, dataTestId: "RoyaltyButton", disabled: disabled ||
            (0, utils_1.shouldDisableByContractType)(contract) ||
            contractFeatures.includes(types_1.ContractFeatures.SOULBOUND) ||
            !hasPermission, variant: variant }));
};
exports.RoyaltyButton = RoyaltyButton;
//# sourceMappingURL=index.js.map